import { Box, Tab } from '@mui/material'
import { TabContext, TabList } from '@mui/lab';
import React from 'react'
import { Link, useLocation } from 'react-router-dom'

export const NavTabs = (props: any) => {    
    return (
        <Box>
            <TabContext value={useLocation().pathname}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <TabList aria-label="Tabs example" >
                        <Tab label="Driver" value="/configurations/driver" to={`/configurations/driver`} component={Link} />
                        <Tab label="Linea" value="/configurations/linea" to={`/configurations/linea`} component={Link} />
                        <Tab label="Box" value="/configurations/view" to={`/configurations/view`} component={Link} />
                        <Tab label="Webapp" value="/configurations/user" to={`/configurations/user`} component={Link} />
                    </TabList>
                </Box>
            </TabContext>
        </Box>
    );
}